'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React from 'react';
import {createPortal} from 'react-dom';
import {ViewMode} from '../../core-utilities/enums/ViewMode';
import {stopPropagation} from '../../core-utilities/react-utils';
import {List} from '../lists/List';
import {DropdownOption} from './DropdownOption';
import {getDisplayValue} from './DropdownOption/DropdownOptionComponent';


export function DropdownView(props) {
  const {
    baseClassName,
    controlClassName,
    menuClassName,
    arrowClassName,
    offset,
  } = props;
  const length = props.options.length;
  const height = `${getHeight(props, length)}px`;
  const style = offset ? {
    top: offset.top + offset.height,
    left: offset.left,
    height,
  } : {
    height,
  };

  return (
    <div
      className={classNames("Dropdown", props.className, `${baseClassName}__root`, {
        DropdownList_isOpen: props.isOpen,
      })}
      ref={props.setContentRef}
    >
      <div
        className={classNames(controlClassName, `${baseClassName}__control`, {
          DropdownList_disabled: props.disabled,
        })}
        onClick={props.onClick}
      >
        {renderValue(props)}
        <span className={classNames(arrowClassName, `${baseClassName}__arrow`)} />
      </div>
      {props.isOpen ? createPortal((
        <div
          className="DropdownList__backdrop"
          onClick={props.onClickBackdrop}
        >
          <div
            className={classNames(menuClassName, `${baseClassName}__menu`)}
            style={style}
            onClick={stopPropagation}
          >
            <List
              className={classNames(menuClassName, `${baseClassName}__list`)}
              useScroll={true}
              flipped={false}
              autoScroll={false}
              showNoData={false}
              mode={ViewMode.SUCCESS}
              onLoadMore={noop}
            >
              {buildMenu(props)}
            </List>
          </div>
        </div>
      ), document.querySelector('body')) : null}
    </div>
  );
}

DropdownView.propTypes = {
  className: T.string,
  baseClassName: T.string,
  controlClassName: T.string,
  placeholderClassName: T.string,
  menuClassName: T.string,
  arrowClassName: T.string,
  options: T.array,
  isOpen: T.bool,
  selected: T.any,
  itemHeight: T.number,
  maxHeight: T.number,
  minToFilter: T.number,
  mode: T.any,
  checkIsSelected: T.func.isRequired,
  getKey: T.func.isRequired,

  setContentRef: T.func,
  onClick: T.func,
  onSelectOption: T.func,
};

DropdownView.defaultProps = {
  baseClassName: 'DropdownList',
  itemHeight: 44,
  maxHeight: 300,
};

function getHeight(props, total) {
  return Math.max(Math.min(total * props.itemHeight, props.maxHeight), 50);
}

function renderValue(props) {
  const optionConfig = props.optionConfig || {};
  const Option = optionConfig.component;
  const customProps = optionConfig.props || {};

  if (optionConfig.component) {
    const option = get(props.selected, 'value') ? props.selected : props.placeholderOption;
    return (
      <div className={classNames(props.placeholderClassName, `${props.baseClassName}__placeholder`)}>
        <Option
          {...customProps}
          key={props.getKey(option.value)}
          className={optionConfig.placeholderClassName}
          model={option}
          isSelected={false}
        />
      </div>
    );
  } else {
    return (
      <div className={classNames(props.placeholderClassName, `${props.baseClassName}__placeholder`)}>
        {getDisplayValue(props.selected.label)}
      </div>
    );
  }
}

function buildMenu(props) {
  const {options, baseClassName} = props;

  if (!options.length && !props.selectNull) {
    return (
      <div className={`${baseClassName}__noresults`}>
        No options found
      </div>
    );
  }

  const optionConfig = props.optionConfig || {};
  const Option = optionConfig.component || DropdownOption;
  const optionClassName = optionConfig.className || `${props.baseClassName}__option`;
  const customProps = optionConfig.props || {};

  return (
    <div>
      {options.map(option => {
        if (option.type === 'group') {
          return (
            <div
              className={`${baseClassName}-group`}
            >
              <div className={`${baseClassName}-title`}>
                {option.name}
              </div>
              {option.items.map(item => (
                <DropdownOption
                  key={props.getKey(item.value)}
                  className={`${props.baseClassName}-option`}
                  model={item}
                  onClick={props.onSelectOption}
                  isSelected={props.checkIsSelected(get(props.selected, 'value'), item.value)}
                />
              ))}
            </div>
          );
        } else {
          return (
            <Option
              {...customProps}
              key={props.getKey(option.value)}
              className={classNames(optionClassName, {
                DropdownList__option_isSelected: props.checkIsSelected(get(props.selected, 'value'), option.value),
              })}
              model={option}
              onClick={props.onSelectOption}
            />
          );
        }
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/js/components/Dropdown/DropdownView.js